import {
    addDays,
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    endOfMonth,
    startOfMonth,
    startOfWeek,
} from 'date-fns';

const mapDateToTextDiff = (date: Date): string => {
    const now = new Date();
    const days = differenceInDays(now, date);
    if (days === 1) return 'Hace 1 día';
    if (days > 1) return `Hace ${days} días`;

    const hours = differenceInHours(now, date);
    if (hours === 1) return 'Hace 1 hora';
    if (hours > 1) return `Hace ${hours} horas`;

    const min = differenceInMinutes(now, date);
    if (min === 1) return 'Hace 1 minuto';
    if (min > 1) return `Hace ${min} minutos`;

    return 'Hace un momento';
};

const getListOfMonthDays = (
    date: Date,
    opts?: { startPadding: boolean }
): (Date | undefined)[] => {
    let monthStart = startOfMonth(date);
    const monthEnd = endOfMonth(date);
    let weekStart = startOfWeek(monthStart, { weekStartsOn: 1 });
    const days = [];

    while (monthStart.getDate() < monthEnd.getDate()) {
        days.push(monthStart);
        monthStart = addDays(monthStart, 1);
    }
    days.push(monthEnd);

    if (opts && opts.startPadding) {
        // Reset start of current month
        monthStart = startOfMonth(date);

        while (weekStart.getDate() != monthStart.getDate()) {
            days.unshift(undefined);
            weekStart = addDays(weekStart, 1);
        }
    }

    return days;
};

const WEEK_DAYS_INITIALS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

const MONTH_NAMES = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
];

export {
    mapDateToTextDiff,
    getListOfMonthDays,
    WEEK_DAYS_INITIALS,
    MONTH_NAMES,
};
